import type { WorkflowSignalType } from "@entrilia/shared/api/workflowTypes";

export const duplicateWarningActions: WorkflowSignalType[] = [
  "SubmitInvoiceForApproval",
  "SubmitInvoiceWithoutConfiguredApproval",
  "CreateInvoiceTransaction",
  "Approve",
];
